import CollapsedPanel from '../components/CollapsedPanel';
import React, { useContext } from 'react';
import CommonStylingPanel from './CommonStylingPanel';
import NumberInput from '../components/NumberInput';
import SelectInput from '../components/SelectInput';
import InputBlock from '../components/InputBlock';
import ColorPicker from '../components/ColorPicker';
import Switcher from '../components/Switcher';
import { EditorContext, SiteContext } from '../../../utils/contexts';
import { TextField } from '@mui/material';

export default function InlineStylingPanel() {
  const { settings, updateSettings } = useContext(EditorContext);
  const site = useContext(SiteContext);

  const updateWidth = (width) => {
    updateSettings({
      width,
    });
  };

  const toggleBorder = () => {
    updateSettings({
      show_border: !settings.show_border,
    });
  };

  const updateBorderColor = (color) => {
    updateSettings({
      border_color: color,
    });
  };

  const updateBorderWidth = (width) => {
    updateSettings({
      border_width: width,
    });
  };

  const updateBorderMargin = (margin) => {
    updateSettings({
      border_margin: margin,
    });
  };

  const toggleShadow = () => {
    updateSettings({
      show_shadow: !settings.show_shadow,
    });
  };

  const updateShadowColor = (color) => {
    updateSettings({
      shadow_color: color,
    });
  };

  return (
    <CollapsedPanel open={false} title="Inline Styling">
      <CommonStylingPanel />
      <InputBlock label="Width">
        <NumberInput
          value={settings.width || 500}
          onChange={updateWidth}
          max={1600}
          step={1}
          size="small"
        />
      </InputBlock>
      <InputBlock label="Border">
        <Switcher checked={!!settings.show_border} onChange={toggleBorder} />
      </InputBlock>
      {settings.show_border && (
        <>
          <InputBlock label="Border Color">
            <ColorPicker
              value={settings.border_color}
              onChange={updateBorderColor}
            />
          </InputBlock>
          <InputBlock label="Border Width">
            <NumberInput
              value={
                typeof settings.border_width === 'number'
                  ? settings.border_width
                  : 2
              }
              onChange={updateBorderWidth}
              min={0}
              max={20}
              size="small"
            />
          </InputBlock>
          <InputBlock label="Border Margin">
            <NumberInput
              value={
                typeof settings.border_margin === 'number'
                  ? settings.border_margin
                  : 0
              }
              onChange={updateBorderMargin}
              min={0}
              max={40}
              size="small"
            />
          </InputBlock>
        </>
      )}
      <InputBlock label="Shadow">
        <Switcher checked={!!settings.show_shadow} onChange={toggleShadow} />
      </InputBlock>
      {settings.show_shadow && (
        <>
          <InputBlock label="Shadow Color">
            <ColorPicker
              value={settings.shadow_color || '000000'}
              onChange={updateShadowColor}
            />
          </InputBlock>
        </>
      )}
      {site.partner !== 'shopify' && (
        <InputBlock
          label="CSS Selector"
          helpText="Select the CSS Selector of the element on your page after where you'd like to insert this inline popup."
          helpUrl="https://support.hellobar.com/support/solutions/articles/44002532599-hello-bar-inline-form"
        >
          <TextField
            onChange={(e) =>
              updateSettings({ inline_css_selector: e.target.value })
            }
            size="small"
            multiline
            maxRows={7}
            fullWidth
            variant="outlined"
            value={settings.inline_css_selector || ''}
            label=""
            placeholder=".classname or #id"
          />
        </InputBlock>
      )}
      {site.partner !== 'shopify' && (
        <InputBlock
          label="Insert at"
          helpText="Select the position where you'd like to insert the new inine popup relative to the css selector element."
        >
          <SelectInput
            items={[
              { value: 'after', label: 'after selected element' },
              { value: 'before', label: 'before selected element' },
              { value: 'replace', label: 'replace selected element' },
            ]}
            value={settings.inline_position || 'after'}
            onChange={(value) => updateSettings({ inline_position: value })}
            size="small"
          />
        </InputBlock>
      )}
    </CollapsedPanel>
  );
}
